export default __webpack_public_path__ + "static/media/logo.a832a9dd.png";